import { useState } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { DeactivateCardDocument, DeactivateCardMutation } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { BankingCard } from 'modules/banking/lib/cards/types'

interface ModalProps {
  card: BankingCard
  onClose: () => void
}

export const DeactivateModal = ({ card, onClose }: ModalProps) => {
  const [submitting, setSubmitting] = useState(false)

  const [deactivateCard, { loading }] = useMutation(DeactivateCardDocument, {
    extractorFn: (data: DeactivateCardMutation) => data.bankingMutations.deactivateBankingCard,
  })

  const handleSubmit = async () => {
    setSubmitting(true)

    const res = await deactivateCard({ variables: { id: card.id + '' } })
    const result = handleResult(res, (errors) => {
      app.setFlash({
        type: 'wrong',
        message: errors['messages'] || i18n.t('errors.generic_error'),
      })
    })

    if (result.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('software_management.software_setups.cards.alerts.cancel_success'),
      })
    }

    setSubmitting(false)
    onClose()
  }

  return (
    <Modal
      title={i18n.t('expenses_v2.cards.actions.modal.deactivate.title')}
      description={i18n.t('expenses_v2.cards.actions.modal.deactivate.description')}
      illustration="alert"
      onSubmit={handleSubmit}
      onClose={onClose}
      footer={
        <Box flexDirection="row" gap="s16">
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button submit disabled={submitting || loading}>
            {i18n.t('expenses_v2.cards.actions.modal.deactivate.text')}
          </Button>
        </Box>
      }
    />
  )
}
